import { Guid } from '@web/utils';

export class PublicCartUpdateItem {
  public constructor(
    private readonly data: {
      quantity: number;
      id: Guid;
    },
  ) {}
  public get id(): Guid {
    return this.data.id;
  }

  public get quantity(): number {
    return this.data.quantity;
  }
}
